import { OnboardingProfile } from '@/lib/api/onboarding/onboarding-api'
import { MdApartment, MdPerson } from 'react-icons/md'

interface Props {
    value: OnboardingProfile | null
    onChange: (profile: OnboardingProfile) => void
}

/**
 * Primeira etapa: quem é a conta. É ela que decide o tamanho do assistente —
 * médico individual responde tudo; clínica/hospital recebe só a carga padrão.
 */
export default function ProfileStep({ value, onChange }: Props) {
    const options: Array<{
        profile: OnboardingProfile
        title: string
        description: string
        icon: React.ReactNode
    }> = [
        {
            profile: 'INDIVIDUAL_DOCTOR',
            title: 'Médico individual',
            description:
                'Você atende com o seu CRM. Vamos cadastrar seu perfil, o local de atendimento, ' +
                'suas especialidades e o valor da consulta.',
            icon: <MdPerson className="text-4xl" />,
        },
        {
            profile: 'CLINIC',
            title: 'Clínica ou hospital',
            description:
                'Vários profissionais atendem na conta. Preparamos o catálogo inicial e você ' +
                'cadastra a equipe depois, no seu ritmo.',
            icon: <MdApartment className="text-4xl" />,
        },
    ]

    return (
        <div className="flex flex-col gap-4">
            <p className="text-base-content/70">
                Para deixar o sistema com a sua cara, precisamos saber como você atende.
            </p>

            <div className="grid gap-4 md:grid-cols-2">
                {options.map(option => {
                    const selected = value === option.profile
                    return (
                        <button
                            key={option.profile}
                            type="button"
                            onClick={() => onChange(option.profile)}
                            className={`text-left rounded-lg border-2 p-5 transition-colors ${
                                selected
                                    ? 'border-secondary bg-secondary/5'
                                    : 'border-base-300 hover:border-secondary/50'
                            }`}
                        >
                            <div
                                className={`mb-3 ${
                                    selected ? 'text-secondary' : 'text-base-content/60'
                                }`}
                            >
                                {option.icon}
                            </div>
                            <p className="font-semibold text-base-content mb-1">
                                {option.title}
                            </p>
                            <p className="text-sm text-base-content/70">
                                {option.description}
                            </p>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
